import React from 'react';
import { ALL_EVENTS_GROUP } from '../../constants';

interface SidebarProps {
  eventGroups: any[];
  setSelectedEventGroup: (group: any) => void;
  selectedEventGroup: any;
}

const Sidebar: React.FC<SidebarProps> = ({ eventGroups, setSelectedEventGroup, selectedEventGroup }) => {
  return (
    <div className="basis-2/12 mb-5">
      <ul className="sidebar">
        <li
          key=""
          onClick={() => setSelectedEventGroup(ALL_EVENTS_GROUP)}
          className={selectedEventGroup && selectedEventGroup.id === ALL_EVENTS_GROUP.id ? 'selected' : ''}
        >
          {ALL_EVENTS_GROUP.name}
        </li>
        {eventGroups.map((group: any) => (
          <li
            key={group.id}
            onClick={() => setSelectedEventGroup(group)}
            className={selectedEventGroup && selectedEventGroup.id === group.id ? 'selected' : ''}
          >
            {group.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
